import React, { useEffect, useRef } from 'react';
import { LayoutDashboardIcon, CheckCircleIcon, SmartphoneIcon, GlobeIcon, AwardIcon, ClipboardCheckIcon, RefreshCwIcon, BuildingIcon } from 'lucide-react';
export const ValueSection = () => {
  const sectionRef = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate-fade-in');
      }
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <section ref={sectionRef} className="py-24 bg-white opacity-0 transition-opacity duration-1000" data-id="element-4472">
      <div className="container mx-auto px-4 md:px-6" data-id="element-4473">
        <div className="max-w-4xl mx-auto mb-14 text-center" data-id="element-4474">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-charcoal tracking-tight" data-id="element-4475">
            Premium Benefits. Unmatched Value.
          </h2>
          <p className="text-xl text-gray-600 max-w-[720px] mx-auto" data-id="element-4476">
            Industry-leading features that set our compliance training apart
          </p>
        </div>
        <div className="max-w-6xl mx-auto grid grid-cols-12 gap-6" data-id="element-4477">
          {/* Row 1 */}
          {/* Manager Dashboard - 6 cols */}
          <div className="col-span-6 row-span-2 rounded-[20px] bg-charcoal overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.08)] transition-all hover:shadow-lg hover:-translate-y-1 duration-300 relative" data-id="element-4478">
            <div className="absolute inset-0 bg-cover bg-center opacity-15 mix-blend-overlay" style={{
            backgroundImage: "url('https://images.unsplash.com/photo-1542744173-05336fcc7ad4?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=2069&q=80')"
          }} data-id="element-4479"></div>
            <div className="p-8 h-full relative z-10" data-id="element-4480">
              <div className="mb-6 inline-flex items-center justify-center w-10 h-10 rounded-lg bg-white/10" data-id="element-4481">
                <LayoutDashboardIcon className="h-5 w-5 text-white" data-id="element-4482" />
              </div>
              <h3 className="text-[22px] font-bold mb-3 text-white" data-id="element-4483">
                Manager Dashboard
              </h3>
              <p className="text-white/80 text-[15px]" data-id="element-4484">
                Assign training, track progress, export reports—all in one
                place.
              </p>
            </div>
          </div>
          {/* Recognized Certificates - 3 cols */}
          <div className="col-span-3 row-span-2 rounded-[20px] bg-charcoal overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.08)] transition-all hover:shadow-lg hover:-translate-y-1 duration-300" data-id="element-4485">
            <div className="p-8 h-full flex flex-col" data-id="element-4486">
              <div className="text-[80px] font-bold text-white mb-2 leading-tight" data-id="element-4487">
                100%
              </div>
              <h3 className="text-[22px] font-bold mb-3 text-white" data-id="element-4488">
                Recognized Certificates
              </h3>
              <p className="text-white/80 text-[15px]" data-id="element-4489">
                Guaranteed acceptance by regulators and industry standards.
              </p>
            </div>
          </div>
          {/* Mobile App - 3 cols */}
          <div className="col-span-3 row-span-2 rounded-[20px] bg-white overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.08)] transition-all hover:shadow-lg hover:-translate-y-1 duration-300" data-id="element-4490">
            <div className="p-8 h-full" data-id="element-4491">
              <div className="mb-6 inline-flex items-center justify-center w-10 h-10 rounded-lg bg-charcoal/10" data-id="element-4492">
                <SmartphoneIcon className="h-5 w-5 text-charcoal" data-id="element-4493" />
              </div>
              <h3 className="text-[22px] font-bold mb-3 text-charcoal" data-id="element-4494">
                Mobile App
              </h3>
              <p className="text-charcoal/80 text-[15px]" data-id="element-4495">
                Train and manage on the go with our iOS & Android app.
              </p>
            </div>
          </div>
          {/* Row 2 */}
          {/* Region-Specific Compliance - 3 cols */}
          <div className="col-span-3 row-span-2 rounded-[20px] bg-white overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.08)] transition-all hover:shadow-lg hover:-translate-y-1 duration-300" data-id="element-4496">
            <div className="p-8 h-full" data-id="element-4497">
              <div className="mb-6 inline-flex items-center justify-center w-10 h-10 rounded-lg bg-charcoal/10" data-id="element-4498">
                <GlobeIcon className="h-5 w-5 text-charcoal" data-id="element-4499" />
              </div>
              <h3 className="text-[22px] font-bold mb-3 text-charcoal" data-id="element-4500">
                Region-Specific Compliance
              </h3>
              <p className="text-charcoal/80 text-[15px]" data-id="element-4501">
                Built for Irish, UK & EU legislation—always audit-ready.
              </p>
            </div>
          </div>
          {/* Certificate Guarantee - 3 cols */}
          <div className="col-span-3 row-span-2 rounded-[20px] bg-teal overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.08)] transition-all hover:shadow-lg hover:-translate-y-1 duration-300" data-id="element-4502">
            <div className="p-8 h-full flex flex-col" data-id="element-4503">
              <div className="flex justify-between items-start mb-6" data-id="element-4504">
                <div className="inline-flex items-center justify-center w-10 h-10 rounded-lg bg-white/10" data-id="element-4505">
                  <AwardIcon className="h-5 w-5 text-white" data-id="element-4506" />
                </div>
                <span className="px-2.5 py-0.5 text-xs font-medium bg-aqua text-white rounded-full flex items-center" data-id="element-4507">
                  Exclusive
                </span>
              </div>
              <h3 className="text-[22px] font-bold mb-3 text-white" data-id="element-4508">
                Certificate Guarantee
              </h3>
              <p className="text-white/80 text-[15px]" data-id="element-4509">
                If a certificate is refused, we'll refund you. T&Cs apply.
              </p>
            </div>
          </div>
          {/* Compliance Records - 3 cols */}
          <div className="col-span-3 row-span-2 rounded-[20px] bg-charcoal overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.08)] transition-all hover:shadow-lg hover:-translate-y-1 duration-300" data-id="element-4510">
            <div className="p-8 h-full" data-id="element-4511">
              <div className="mb-6 inline-flex items-center justify-center w-10 h-10 rounded-lg bg-white/10" data-id="element-4512">
                <ClipboardCheckIcon className="h-5 w-5 text-white" data-id="element-4513" />
              </div>
              <h3 className="text-[22px] font-bold mb-3 text-white" data-id="element-4514">
                Compliance Records
              </h3>
              <p className="text-white/80 text-[15px]" data-id="element-4515">
                Centralized storage for certificates, reports, and
                logs—inspection-ready.
              </p>
            </div>
          </div>
          {/* Enterprise Academy - 3 cols */}
          <div className="col-span-3 row-span-4 rounded-[20px] bg-charcoal overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.08)] transition-all hover:shadow-lg hover:-translate-y-1 duration-300" data-id="element-4516">
            <div className="p-8 h-full flex flex-col" data-id="element-4517">
              <div className="mb-6 inline-flex items-center justify-center w-10 h-10 rounded-lg bg-white/10" data-id="element-4518">
                <BuildingIcon className="h-5 w-5 text-white" data-id="element-4519" />
              </div>
              <h3 className="text-[22px] font-bold mb-3 text-white" data-id="element-4520">
                Enterprise Academy
              </h3>
              <p className="text-white/80 text-[15px] mb-6" data-id="element-4521">
                Your own white-label academy—custom domain, onboarding, advanced
                reporting.
              </p>
              <div className="flex flex-wrap gap-3 mt-auto" data-id="element-4522">
                <div className="h-[60px] w-[64px] bg-white/10 rounded-lg" data-id="element-4523"></div>
                <div className="h-[60px] w-[64px] bg-white/10 rounded-lg" data-id="element-4524"></div>
                <div className="h-[60px] w-[64px] bg-white/10 rounded-lg" data-id="element-4525"></div>
                <div className="h-[60px] w-[64px] bg-white/10 rounded-lg" data-id="element-4526"></div>
              </div>
            </div>
          </div>
          {/* Row 3 */}
          {/* Unlimited Retries - 3 cols */}
          <div className="col-span-3 row-span-2 rounded-[20px] bg-white overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.08)] transition-all hover:shadow-lg hover:-translate-y-1 duration-300" data-id="element-4527">
            <div className="p-8 h-full" data-id="element-4528">
              <div className="mb-6 inline-flex items-center justify-center w-10 h-10 rounded-lg bg-charcoal/10" data-id="element-4529">
                <RefreshCwIcon className="h-5 w-5 text-charcoal" data-id="element-4530" />
              </div>
              <h3 className="text-[22px] font-bold mb-3 text-charcoal" data-id="element-4531">
                Unlimited Retries
              </h3>
              <p className="text-charcoal/80 text-[15px]" data-id="element-4532">
                Never locked out—practice until you're confident and ready.
              </p>
            </div>
          </div>
          {/* Completion Tracking - 3 cols */}
          <div className="col-span-3 row-span-2 rounded-[20px] bg-white overflow-hidden shadow-[0_4px_20px_rgba(0,0,0,0.08)] transition-all hover:shadow-lg hover:-translate-y-1 duration-300" data-id="element-4533">
            <div className="p-8 h-full" data-id="element-4534">
              <div className="mb-6 inline-flex items-center justify-center w-10 h-10 rounded-lg bg-charcoal/10" data-id="element-4535">
                <CheckCircleIcon className="h-5 w-5 text-charcoal" data-id="element-4536" />
              </div>
              <h3 className="text-[22px] font-bold mb-3 text-charcoal" data-id="element-4537">
                Completion Tracking
              </h3>
              <p className="text-charcoal/80 text-[15px]" data-id="element-4538">
                Real-time progress tracking with detailed completion analytics.
              </p>
            </div>
          </div>
        </div>
        <div className="mt-16 text-center" data-id="element-4539">
          <div className="inline-block py-2 px-5 bg-gray-50 rounded-full" data-id="element-4540">
            <span className="text-charcoal font-medium text-sm" data-id="element-4541">
              <span className="text-teal" data-id="element-4542">Trusted by</span> 1000+ businesses
              across Europe
            </span>
          </div>
        </div>
      </div>
    </section>;
};